import "./root.ezitxt.css"; // EziTxt design-system tokens (side-effect import)
import type { Theme } from "../types";
import { EziLogo } from "./EziLogo";

export const ezitxt: Theme = {
  id: "ezitxt",
  name: "EziTxt",
  Logo: EziLogo,
};
